import {
  Avatar,
  Flex,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Text,
} from "@chakra-ui/react"
import { AuthContext, IAuthContext } from "context/authContext"
import { useSidebarContext } from "context/sidebarContext"
import { UserContext } from "context/userContext"
import { FC, useContext } from "react"
import { FiLogOut, FiMoreVertical } from "react-icons/fi"
import { useQueryClient } from "react-query"

export const UserMenu: FC = () => {
  const { isCollapsed } = useSidebarContext()
  const { username } = useContext(UserContext)
  const { signOut } = useContext<IAuthContext>(AuthContext)
  const queryClient = useQueryClient()

  const handleSignOut = () => {
    signOut()
    queryClient.clear()
  }

  // Инициалы вместо пустого силуэта
  const avatar = <Avatar size="sm" name={username} bg="purple.500" color="white" />

  return (
    <Flex w="full" alignItems="center" justifyContent="center" gap={3}>
      {/* Кнопка — только "⋮" (а в свёрнутой панели — сама аватарка),
          а не весь блок: подсветка всего блока с отступами смотрелась плохо */}
      <Menu placement="top-start">
        {isCollapsed ? (
          <MenuButton
            as={IconButton}
            aria-label="Меню пользователя"
            isRound
            variant="ghost"
            h="auto"
            minW="auto"
            p={0}
            icon={avatar}
            _hover={{ boxShadow: "0 0 0 3px var(--chakra-colors-purple-100)" }}
            _active={{ boxShadow: "0 0 0 3px var(--chakra-colors-purple-200)" }}
          />
        ) : (
          <>
            {avatar}
            <Text flex={1} noOfLines={1} fontSize="sm" fontWeight="medium" color="gray.700">
              {username}
            </Text>
            <MenuButton
              as={IconButton}
              aria-label="Меню пользователя"
              size="sm"
              variant="ghost"
              color="gray.500"
              icon={<Icon as={FiMoreVertical} boxSize={4} />}
            />
          </>
        )}

        {/* Как выпадашка выбора раздела: отступ внутри, скруглённые пункты.
            В портале и с zIndex выпадашек: обёртка меню по умолчанию z=1, и
            его перекрывала липкая полоса с кнопками на странице проверки */}
        <Portal>
          <MenuList
            rootProps={{ zIndex: "dropdown" }}
            minW="180px"
            p={1.5}
            borderRadius="lg"
            boxShadow="lg"
            fontSize="sm"
          >
            <MenuItem
              icon={<Icon as={FiLogOut} boxSize={4} />}
              px={3}
              py={2}
              borderRadius="md"
              color="red.600"
              fontWeight="medium"
              _hover={{ bg: "red.50" }}
              _focus={{ bg: "red.50" }}
              onClick={handleSignOut}
            >
              Выйти
            </MenuItem>
          </MenuList>
        </Portal>
      </Menu>
    </Flex>
  )
}
